module.exports = __webpack_public_path__ + "static/download_apple-81c737f3c5f99352101db85a8bef54be.png";